/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
import { RequireBy } from './utill-types';

export interface UrlConfig {
  title: string;
  url: string;
}

export interface AppConfigurationUrls {
  url: string;
  acceptanceUrl?: string | UrlConfig[];
  specialistUrl?: string;
}

export interface AppConfigurationOptions extends AppConfigurationUrls {
  name: ApplicationName;
}

export interface ApplicationConfiguration {
  apps: AppConfigurationOptions[];
}

export type PickRequired<Type, Key extends keyof Type> = Type & {
  [Property in Key]-?: Type[Property];
};

export type MakeRequired<Type, Key extends keyof Type> = Type & {
  [Property in Key]-?: Type[Property];
};

/// /////////////////////////////

export const APPLICATION_NAMES = ['bodem', 'asbest', 'rapportage', 'atlas', 'bbm'] as const;

export type ApplicationName = typeof APPLICATION_NAMES[number];

export type EnvironmentOptions = {
  url: string;
  title: string;
  badgeContent?: string | number;
};

export type Environment = string | EnvironmentOptions[];

export const DTAP_STEPS = ['development', 'testing', 'acceptance', 'production'] as const;

export type DtapStep = typeof DTAP_STEPS[number];

export interface Application {
  name: ApplicationName;
  url: string;
  title?: string;
  tooltipText?: string;
  alternativeEnvironments?: Partial<Record<DtapStep, Environment>>;
}
